import { useEffect, useRef, useState } from "react";
import { useActiveTrip } from "../../hooks/use-active-trip";
import { useTripActions, useTripContext } from "../../state/trip-context";
import { CreateTripDialog } from "./create-trip-dialog";
import { TripDetail } from "./trip-detail";
import { TripEmpty } from "./trip-empty";
import { TripOverview } from "./trip-overview";
import { parseShareHash } from "./trip-export";

export function TripPlanner() {
  const { state } = useTripContext();
  const { createTripRaw, setActiveTrip } = useTripActions();
  const activeTrip = useActiveTrip();
  const [dialogOpen, setDialogOpen] = useState(false);

  const openDialog = () => setDialogOpen(true);
  const closeDialog = () => setDialogOpen(false);

  // Handle ?t=<hash> share-link imports. We only hydrate once per
  // page load; if the trip already exists by id we just jump to
  // it instead of duplicating.
  const hydratedRef = useRef(false);
  useEffect(() => {
    if (hydratedRef.current) return;
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const hash = params.get("t");
    if (!hash) return;
    hydratedRef.current = true;
    const incoming = parseShareHash(hash);
    if (!incoming) return;
    const exists = state.trips.find((t) => t.id === incoming.id);
    if (exists) {
      setActiveTrip(incoming.id);
    } else {
      createTripRaw(incoming);
    }
    // Clean the URL so a reload doesn't re-import.
    const url = new URL(window.location.href);
    url.searchParams.delete("t");
    window.history.replaceState({}, "", url.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let body;
  if (state.trips.length === 0) {
    body = <TripEmpty onCreate={openDialog} />;
  } else if (activeTrip) {
    body = <TripDetail trip={activeTrip} />;
  } else {
    body = <TripOverview trips={state.trips} onCreate={openDialog} />;
  }

  return (
    <>
      {body}
      <CreateTripDialog open={dialogOpen} onClose={closeDialog} />
    </>
  );
}
